import React, {useState} from "react";
import {ProductionStageProgress} from "../../../model/production-order/ProductionOrder";
import {TbMessageReport} from "react-icons/tb";
import {ProductionStageDowntimeActModal} from "./production-stage-downtime-act-modal/ProductionStageDowntimeActModal";

interface TableProps {
    documentNumber: number;
    tableData: ProductionStageProgress[];
}

function getExecutionStatus(stageProgress: ProductionStageProgress) {
    if (stageProgress.percentageProgress === 0) {
        return "В очереди"
    }
    if (stageProgress.percentageProgress === 100) {
        return "Выполнено"
    }
    return "В работе"
}

export function ExecutionByProductionStagesTable(props: TableProps) {
    const [productionStageId, setProductionStageId] = useState<number | null>(null);

    return (
        <>
            <table className='w-fit mx-2'>
                <thead>
                    <tr>
                        <th className="border border-black text-sm font-normal text-center px-1.5">Этап</th>
                        <th className="border border-black text-sm font-normal text-center px-1.5">Выполнение</th>
                        <th className="border border-black text-sm font-normal text-center px-1.5">Статус</th>
                        <th className="border border-black text-sm font-normal text-center px-1.5"></th>
                    </tr>
                </thead>
                <tbody>
                    {props.tableData.map(stage => <tr key={stage.productionStage.id}>
                        <td className="border border-black text-sm font-light px-1.5">{stage.productionStage.name}</td>
                        <td className="border border-black text-sm font-light px-1.5">{`${stage.quantityProgress.actualQuantity}/${stage.quantityProgress.planningQuantity}`}</td>
                        <td className="border border-black text-sm font-light px-1.5">{getExecutionStatus(stage)}</td>
                        <td className="border border-black text-sm font-light px-1.5"><TbMessageReport title='Акт простоя' className='h-5 w-5 stroke-1 cursor-pointer' onClick={() => setProductionStageId(stage.productionStage.id)}/></td>
                    </tr>)}
                </tbody>
            </table>
            <ProductionStageDowntimeActModal key={productionStageId} onModalClose={() => setProductionStageId(null)}
                                            productionStageId={productionStageId} documentNumber={props.documentNumber}/>
        </>
    )
}